import React from 'react';
import { DeleteButtonStyle } from './DeleteButton.styles';
import { CircleX } from 'lucide-react';

interface DeleteButtonProps {
  onClick: () => void;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({ onClick }) => (
  <DeleteButtonStyle
    onClick={onClick}
    aria-label="Delete">
    <CircleX size={18} strokeWidth={2.5} />
  </DeleteButtonStyle>
);